import { useState, useEffect } from "react";

const TABS = [
  { key: "cvss",   label: "CVSS v3.1" },
  { key: "cvss4",  label: "CVSS v4.0" },
  { key: "ssvc",   label: "SSVC" },
  { key: "cwe",    label: "CWE" },
  { key: "reftag", label: "Ref Tagging" },
  { key: "news",   label: "News" },
];

export default function ConfigPage() {
  const [tab, setTab] = useState("cvss");
  const [prompts, setPrompts] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("/api/config/prompts")
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(setPrompts)
      .catch((e) => setError(e.message));
  }, []);

  if (error) return <div className="panel"><div className="panel-body">Error loading prompts: {error}</div></div>;
  if (!prompts) return <div className="panel"><div className="panel-body">Loading prompts...</div></div>;

  const current = prompts[tab];
  if (!current) return <div className="panel"><div className="panel-body">No prompt data for {tab}</div></div>;

  const isNews = tab === "news";

  return (
    <>
      <div className="metrics-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`metrics-tab ${tab === t.key ? "metrics-tab-active" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="panel">
        <div className="panel-header">
          {isNews ? "Prompt (daily_news.txt)" : "User Prompt Template"}
        </div>
        <div className="panel-body">
          <pre className="config-prompt-block">{current.user}</pre>
        </div>
      </div>

      {!isNews && (
        current.system ? (
          <div className="panel">
            <div className="panel-header">System Prompt (Guide)</div>
            <div className="panel-body">
              <pre className="config-prompt-block">{current.system}</pre>
            </div>
          </div>
        ) : (
          <div className="panel">
            <div className="panel-header">System Prompt</div>
            <div className="panel-body">
              <span style={{ color: "var(--text-muted)" }}>No system prompt for this scoring type</span>
            </div>
          </div>
        )
      )}
    </>
  );
}
